/* eslint-disable max-len */
import React from 'react';
import { Text, Pane, Flex, Button, Label, PortalOverlay } from '@leverege/ui-elements';
// import I18N from '@leverege/i18n'
import classes from './Classes.css';

// const { t } = I18N.ns( 'recovrGeneric.ownershipTransfer' )
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export default function InitiateTransferView(props) {
  const {
    onClose,
    deviceErrors,
    objectType
  } = props;
  const singularDeviceTerm = objectType === 'locator' ? 'Locator' : 'Equipment';
  // eslint-disable-next-line no-unused-vars
  const pluralDeviceTerm = objectType === 'locator' ? 'Locators' : 'Equipments';
  const errorTitles = {
    locator: {
      paired: 'Locators Paired',
      offline: 'Locators Offline',
      transferPending: 'Transfer in Progress'
    },
    assetLocators: {
      unpaired: 'No Paired Locator',
      locatorOffline: 'Locators Offline',
      transferPending: 'Transfer in Progress'
    }
  };
  const renderDevicesWithError = (error, objectType, devicesWithError) => {
    if (devicesWithError.length) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(Label, {
          style: {
            paddingTop: '16px',
            paddingBottom: '8px',
            fontSize: '16px'
          },
          children: [" ", errorTitles[objectType][error], " "]
        }), /*#__PURE__*/_jsx(Pane, {
          style: {
            height: '120px',
            padding: '16px',
            backgroundColor: 'white',
            borderRadius: '4px',
            border: '1px solid #CED6DE'
          },
          children: devicesWithError.map(deviceName => /*#__PURE__*/_jsxs(Text, {
            style: {
              paddingBottom: '8px'
            },
            children: [" ", deviceName, " "]
          }))
        })]
      });
    }
    return null;
  };
  const iconBackgroundStyle = {
    height: '24px',
    width: '24px',
    borderRadius: '2px',
    backgroundColor: '#F0F6FF',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative'
  };
  const iconStyle = {
    color: '#1646C5',
    position: 'absolute',
    align: 'center'
  };
  const renderForm = () => /*#__PURE__*/_jsxs(Pane, {
    variant: "editorDialog",
    className: classes.dialog,
    children: [/*#__PURE__*/_jsxs(Flex, {
      className: classes.dialogHeader,
      justify: "space-between",
      children: [/*#__PURE__*/_jsx(Text, {
        style: {
          fontWeight: 'bold'
        },
        icon: /*#__PURE__*/_jsx(Flex, {
          style: {
            ...iconBackgroundStyle
          },
          children: /*#__PURE__*/_jsx("img", {
            src: "https://storage.googleapis.com/prd-generic-kudelski-ui-assets/Screen%20Icons/screen-transfers-red.svg",
            alt: "Transfer Error Icon",
            style: {
              ...iconStyle
            }
          })
        }),
        children: "Transfer Error"
      }), /*#__PURE__*/_jsx(Button, {
        variant: "closeWindow",
        icon: "fa fa-remove",
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(Pane, {
      className: classes.dialogBody,
      children: /*#__PURE__*/_jsxs(Flex, {
        variant: "col",
        justify: "space-between",
        children: [/*#__PURE__*/_jsxs(Text, {
          variant: "bodySmall",
          style: {
            lineHeight: '26px',
            fontSize: '16px'
          },
          children: [singularDeviceTerm, "(s) cannot be transferred due to specific conditions. Please replace the following items(s) in order to continue with the transfer:"]
        }), Object.keys(deviceErrors).map(error => renderDevicesWithError(error, objectType, deviceErrors[error]))]
      })
    })]
  });
  return /*#__PURE__*/_jsx(PortalOverlay, {
    position: "center",
    show: true,
    closeOnEscape: false,
    closeOnDocumentClick: false,
    children: renderForm()
  });
}